import { render } from "./EventList.vue?vue&type=template&id=2cf2732c&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=2cf2732c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cf2732c"

export default script